export default __webpack_public_path__ + "f82b3f91e3c62105102af679d44f5685.png";